import { Row } from "antd";
import { Col, Container } from "react-bootstrap";

import { useState } from "react";
export default function HomeContent() {
  return (
    <>
      <div className="pt-4 spacing">
        <Container fluid>
          <Row>
            <Col xs={12}>
              <h2>
                Best and Famous Astrologer in Gurgaon -Dr. Surabhi Bhatnagar
              </h2>
                  <p className="mb-0">
                <a className="fw-bold" href="/book-an-appointment">
                  Book your consultation
                </a>{" "}
                with Dr. Surabhi Bhatnagar and experience the power of
                personalized astrological guidance.
              </p>
              <p className="mb-0 mt-3">
                At Blessings Astrology, we offer reliable and personalized
                astrological guidance through years of experience complemented
                by deep spiritual understanding. Our consultations are led by
                Dr. Surabhi Bhatnagar, a highly respected astrology consultant
                in Gurgaon/ Gurugram known for her knowledge and compassionate
                approach. Recognized as the Top Astrologer in Delhi NCR, Dr.
                Surabhi combines Vedic astrology with modern insights to provide
                solutions that truly transform lives. As one of the Top
                Astrologers in Gurgaon/Gurugram, she provides in-depth and
                personalized insights that encompass all aspects of life,
                including career, business, relationships, well-being, and
                finances. Apart from horoscope consultations, our services
                include numerology, vastu consultations, corporate astrological
                solutions, tarot card reading, and more. Every session is
                designed to bring clarity, practical remedies, and spiritual
                alignment to help you make confident and informed choices.
              </p>
              <p className="service-we-offer">
                Services we offer:
                <a href="https://www.blessingsastrology.com/service/astrology">
                  Astrology
                </a>
                |
                <a href="https://www.blessingsastrology.com/service/vastu-shastra">
                  Vastu Shastra
                </a>
                |
                <a href="https://www.blessingsastrology.com/service/tarot">
                  Tarot Card Reading
                </a>
                |
                <a href="https://www.blessingsastrology.com/service/palmistry">
                  Palmistry
                </a>
                |
                <a href="https://www.blessingsastrology.com/service/numerology">
                  Numerology
                </a>
                |
                <a href="https://www.blessingsastrology.com/service/reiki-healing">
                  Reiki Healing
                </a>
                |
                <a href="https://www.blessingsastrology.com/service/puja">
                  Puja
                </a>
                |
                <a href="https://www.blessingsastrology.com/service/handwriting-and-signature-analysis">
                  Handwriting and Signature Analysis
                </a>
                |
                <a href="https://www.blessingsastrology.com/service/corporate-training">
                  Corporate Training
                </a>
                .
              </p>

              <h2 className="mt-3">
                Astrology and Vastu Consultant in Gurgaon
              </h2>
              <p>
                Along with astrology, we also provide consultation as an
                Astrology and Vastu Consultant in Gurgaon. Many challenges arise
                when planetary influences and living spaces are not balanced. By
                combining Astrology and Vastu principles, we help enhance
                positivity at home and the workplace, improve financial growth,
                reduce conflicts, and support peace and harmony in daily life.
                Even small Vastu corrections can bring powerful transformations
                over time.
              </p>

              {/* <h2>Trusted Guidance from Best astrologer in Gurgaon, India</h2>
              <p className="mb-0">
                At Blessings Astrology, we offer reliable and personalized astrological guidance through years of experience complemented by deep spiritual understanding. Our consultations are led by Dr. Surabhi Bhatnagar, a highly respected astrology consultant in Gurgaon known for her knowledge and compassionate approach. Recognized as the Best Astrologer in Delhi NCR, Dr. Surabhi combines Vedic astrology with modern insights to provide solutions that truly transform lives. As one of the Best Astrologers in India, she delivers in-depth and individualized insights that cover all aspects of life, career, business, relationships, well-being, and finances. Apart from horoscope consultations, our services include numerology, vastu consultations, corporate astrological solutions, tarot card reading, and more. Every session is designed to bring clarity, practical remedies, and spiritual alignment to help you make confident and informed choices.
              </p>
              <p className="mb-0">
                <a
                  className="fw-bold"
                  href="/book-an-appointment">
                  Book your consultation
                </a> with Dr. Surabhi Bhatnagar and experience the power of personalized astrological guidance.

              </p> */}
            </Col>
          </Row>
          <Row className="mt-2">
            <Col xs={12}>
              <h2>Your search for “Astrologer Near Me” ends here</h2>
              <p className="mb-0">
                If you have been looking for an "Astrologer Near Me" or “Best
                Astrologer in Gurgaon/ Gurugram”, “the Best Astrologer in Delhi
                NCR”, or “Best Astrologers in India”, your quest ends at
                Blessings Astrology. Under the guidance of Dr. Surabhi
                Bhatnagar, the best astrologer and vastu expert, we offer you
                precise, personalized, and empathetic astrological solutions.
                Life tends to bring difficulties in relationships, work, health,
                and money, and it is only natural to look for advice that
                transcends top-level guidance. Having spent decades practicing
                and learning about Vedic astrology, Dr. Surabhi can provide you
                with insights that enable you to see your life path and make
                better-informed choices with confidence.
              </p>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
}
